import {AfterViewChecked, Component, ElementRef, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgInputComponent} from 'exc-controls-v2';

@Component({
  selector: 'app-textarea-input',
  templateUrl: './exg-textarea-input.component.html',
  styles: [
  ]
})
export class ExgTextareaInputComponent extends ExcTranslation implements OnInit, AfterViewChecked {
  @Input()
  set value(value: string) {
    value = value ? value : '';
    this._value = value;
    this.valueClone = this.clone(value);
  }
  get value(): string {
    return this._value;
  }
  @ViewChild('VCInput', {read: ExgInputComponent}) VCInput!: ExgInputComponent;
  @ViewChild('VCInputArea', {read: ElementRef}) VCInputArea!: ElementRef;

  @Input()
  set caption(input: any) {
    this._caption = input;
  }
  get caption(): any {
    return this._caption;
  }

  @Input()
  maxCLength: undefined | number;
  _caption = 'inputText';

  init = true;
  visibilityController = {
    defaultValue: {
      areaVisible: false
    },
    setDefault: () => {
      this.visibilityController.areaVisible = this.visibilityController.defaultValue.areaVisible;
    },
    /******/
    areaVisible: false,
    switch: () => {
      this.visibilityController.areaVisible = !this.visibilityController.areaVisible;
    }
  };
  _value = '';
  valueClone = '';

  constructor() {
    super();
  }

  ngAfterViewChecked(): void {

  }

  ngOnInit(): void {
  }

  changeFocus($event: FocusEvent): void {
    if ($event.type === 'focusin') {
      if (!this.visibilityController.areaVisible) {
        this.visibilityController.switch();
      }
      setTimeout(() => {
        (this.VCInputArea.nativeElement.children[0].children[0]).focus();
      }, 30);
    }

    if ($event.type === 'focusout') {
      if (this.value.length === 0) {
        this.visibilityController.setDefault();
      }
    }
  }

  clone(cloneObj: any): any {
    return JSON.parse(JSON.stringify(cloneObj));
  }

  @Output()
  get valueChanged(): boolean {
    return JSON.stringify(this._value) !== JSON.stringify(this.valueClone);
  }
}
